var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('jz-container',{staticClass:"exercise-hints"},_vm._l((_vm.hints),function(hint,index){return _c('jz-container',{key:index,staticClass:"hint"},[_vm._v(" "+_vm._s(hint)+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }